import { Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

import ROUTE_CONSTANTS from "@/constants/route-constants";
import DashboardHeader from "@/components/app/DashboardHeader";
import { useCheckPermissionAccess } from "@/hooks/useCheckPermissionAccess";
import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";

export default function GenreHeader() {
    const createAccess = useCheckPermissionAccess(PagesAccess.GENRE, OperationAccess.CREATE);

    return (
        <DashboardHeader
            title="Tags"
            titleSuffix={
                createAccess ? (
                    <Button
                        color="primary"
                        component={Link}
                        to={ROUTE_CONSTANTS.CONTENT_MANAGEMENT.GENRES.ADD_NEW.ROOT.ABSOLUTE}
                        variant="contained"
                    >
                        Add New Tag
                    </Button>
                ) : null
            }
        >
            <Typography className="page-title">Tags List</Typography>
            <Typography component="p">List of all tags in the table.</Typography>
            <Typography component="p">tags are based on being education and entertainment.</Typography>
            <Typography component="p">You can add, edit, and delete tags.</Typography>
            <Typography component="p">Additionally, you can search, sort, and filter tags in the table.</Typography>
        </DashboardHeader>
    );
}
